import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Define the initial state
const initialState = {
  cart: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk for fetching cart
export const fetchCart = createAsyncThunk(
  'cart/fetchCart',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState(); // Access Redux state
      const token = state?.auth?.access_token; // Adjust this path if needed

      const response = await axios.get('https://nanosoft.technology/smile/api/cart', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return response.data.data; // Return cart data
    } catch (error) {
      console.error('API Error:', error.response || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create the slice
const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCart.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCart.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.cart = action.payload;
      })
      .addCase(fetchCart.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export default cartSlice.reducer;
